<template>
  <v-container fluid>
    <v-layout>
      <v-flex xs12>
        <create-typology-size :typology-id="typology.id"
                              v-on:create-size="create($event)">
        </create-typology-size>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex xs12>
        <v-data-table
          :headers="headers"
          :items="typology.typology_sizes"
          hide-actions
          class="elevation-1">
          <template slot="items" slot-scope="props">
            <td class="text-xs-center">{{ props.item.id }}</td>
            <td class="text-xs-center">{{ props.item.min }}</td>
            <td class="text-xs-center">{{ props.item.max }}</td>
            <td class="text-xs-center">{{ props.item.enviromental_study_type.name }}</td>
            <td class="text-xs-center">
              <v-layout row justify-center>
                <edit-typology-size :typology="typology"
                                    :typology-size="Object.assign({},props.item)"/>
                <remove-typology-size :typology="typology" :typology-size="props.item"/>
              </v-layout>
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import CreateTypologySize from '@/components/configurations/typology/show/enviromental_study/create_typology_size/CreateTypologySize';
import EditTypologySize from '@/components/configurations/typology/show/enviromental_study/edit_typology_size/EditTypologySize';
import RemoveTypologySize from '@/components/configurations/typology/show/enviromental_study/remove_typology_size/RemoveTypologySize';

import EnviromentalStudyType from '@/services/applications/configurations/EnviromentalStudyTypeService';

export default {
  name: 'EnviromentalStudy',
  props: ['typology'],
  components: {
    CreateTypologySize,
    EditTypologySize,
    RemoveTypologySize,
  },
  mounted() {
    EnviromentalStudyType
      .fetchEnviromentalStudyTypes()
      .then((response) => {
        this.enviromentalStudyTypes = response.data;
      });
  },
  data() {
    return {
      dialog: false,
      dialogEditTypologySize: false,
      enviromentalStudyTypes: [],
      headers: [
        { text: 'ID', value: 'id', align: 'center' },
        { text: 'Min', value: 'min', align: 'center' },
        { text: 'Max', value: 'max', align: 'center' },
        { text: 'Estudo Ambiental Exigido', value: 'enviromental_study_type', align: 'center' },
        { text: 'Ações', value: 'actions', align: 'center' }],
      valid: false,
    };
  },
  methods: {
    create(event) {
      this.typology.typology_sizes.push(event);
    },
    update(event) {
      this.typology.typology_sizes.forEach((item, index) => {
        if (item.id === event.id) {
          Object.assign(this.typology.typology_sizes[index], event);
        }
      });
    },
    remove(event) {
      this.typology.typology_sizes.forEach((item, index) => {
        if (item.id === event.id) {
          Object.assign(this.typology.typology_sizes[index], event);
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
</style>
